import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-100 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "px-4 py-4 sm:px-6" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = { class: "divide-y divide-gray-200 px-4 sm:px-6" }
const _hoisted_7 = { class: "space-y-6 pt-5 pb-5" }
const _hoisted_8 = {
  for: "title",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_9 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_11 = { class: "flex grow flex-col mr-3" }
const _hoisted_12 = { class: "flex grow flex-col mr-3" }
const _hoisted_13 = { class: "space-y-6 pt-5 pb-5" }
const _hoisted_14 = {
  for: "folder-url",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_15 = { class: "mt-3 grid grid-cols-1" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "block text-sm/6 font-medium text-gray-900" }
const _hoisted_18 = { class: "mt-2 flex flex-wrap items-center gap-1.5" }
const _hoisted_19 = ["onClick", "title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "mt-2 text-xs text-gray-500" }
const _hoisted_22 = { class: "flex shrink-0 justify-between px-4 py-4 bg-gray-50" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_SwitchLabel = _resolveComponent("SwitchLabel")!
  const _component_SwitchDescription = _resolveComponent("SwitchDescription")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_SwitchGroup = _resolveComponent("SwitchGroup")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!
  const _component_DeleteFolderConfirmationModalComponent = _resolveComponent("DeleteFolderConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.open
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          class: "relative z-100",
          onClose: _ctx.handleDialogClose
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransitionChild, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_TransitionChild, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" }, {
                      default: _withCtx(() => [
                        _createElementVNode("form", {
                          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
                          class: "flex flex-col divide-y divide-gray-200 bg-white"
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_DialogTitle, { class: "text-base font-semibold text-gray-900" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('edit_folder_modal.title')), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("button", {
                                type: "button",
                                class: "relative rounded-md text-gray-400 hover:text-gray-500 focus-visible:ring-2 focus-visible:ring-royal-blue-500 focus:outline-hidden",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                              }, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('edit_folder_modal.cancel')), 1),
                                _createVNode(_component_XMarkIcon, {
                                  class: "size-6",
                                  "aria-hidden": "true"
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('create_gallery.name')), 1),
                                _createElementVNode("div", _hoisted_9, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "title",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
                                    type: "text",
                                    autocomplete: "title",
                                    class: _normalizeClass({
                                                        'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                                        'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('title')
                                                    })
                                  }, null, 2), [
                                    [_vModelText, _ctx.form.title]
                                  ]),
                                  (_ctx.hasError('title'))
                                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                        key: 0,
                                        class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                        "aria-hidden": "true"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.hasError('title'))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.getError('title')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_SwitchGroup, {
                                  as: "div",
                                  class: "flex items-center justify-between"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_11, [
                                      _createVNode(_component_SwitchLabel, {
                                        as: "span",
                                        class: "text-sm/6 font-medium text-gray-900",
                                        passive: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('edit_folder_modal.hide_label')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_SwitchDescription, {
                                        as: "span",
                                        class: "text-sm text-gray-500"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('edit_folder_modal.hide_description')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createVNode(_component_Switch, {
                                      modelValue: _ctx.form.is_hidden,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_hidden) = $event)),
                                      class: _normalizeClass([_ctx.form.is_hidden ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          "aria-hidden": "true",
                                          class: _normalizeClass([_ctx.form.is_hidden ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'])
                                        }, null, 2)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "class"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_SwitchGroup, {
                                  as: "div",
                                  class: "flex items-center justify-between"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_12, [
                                      _createVNode(_component_SwitchLabel, {
                                        as: "span",
                                        class: "text-sm/6 font-medium text-gray-900",
                                        passive: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('edit_folder_modal.hide_photos_label')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_SwitchDescription, {
                                        as: "span",
                                        class: "text-sm text-gray-500"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('edit_folder_modal.hide_photos_description')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createVNode(_component_Switch, {
                                      modelValue: _ctx.form.hide_photos,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.hide_photos) = $event)),
                                      class: _normalizeClass([_ctx.form.hide_photos ? 'bg-royal-blue-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          "aria-hidden": "true",
                                          class: _normalizeClass([_ctx.form.hide_photos ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block size-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'])
                                        }, null, 2)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "class"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('edit_folder_modal.url_label')), 1),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("input", {
                                    type: "text",
                                    readonly: "",
                                    id: "folder-url",
                                    class: "col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 sm:pr-9 sm:text-sm/6",
                                    value: _ctx.form.public_url
                                  }, null, 8, _hoisted_16),
                                  (_openBlock(), _createElementBlock("svg", {
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args)), ["prevent"])),
                                    class: "cursor-pointer col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-gray-400 sm:size-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 18 18"
                                  }, _cache[12] || (_cache[12] = [
                                    _createElementVNode("g", {
                                      transform: "translate(1 1)",
                                      stroke: "#000",
                                      "stroke-width": "1.5",
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    }, [
                                      _createElementVNode("rect", {
                                        width: "10.4",
                                        height: "10.4",
                                        x: "5.6",
                                        y: "5.6",
                                        rx: "1.6"
                                      }),
                                      _createElementVNode("path", { d: "M2.4 10.4h-.8A1.6 1.6 0 010 8.8V1.6A1.6 1.6 0 011.6 0h7.2a1.6 1.6 0 011.6 1.6v.8" })
                                    ], -1)
                                  ])))
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('edit_folder_modal.color_label')), 1),
                                _createElementVNode("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorPresets, (preset) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: preset,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.form.color = preset),
                                      title: preset,
                                      style: _normalizeStyle({ backgroundColor: preset }),
                                      class: _normalizeClass([
                                                        'size-5 rounded-full cursor-pointer transition ring-offset-1 ring-offset-white',
                                                        _ctx.form.color && _ctx.form.color.toLowerCase() === preset.toLowerCase()
                                                            ? 'ring-2 ring-gray-900'
                                                            : 'ring-1 ring-gray-200 hover:ring-gray-400'
                                                    ])
                                    }, null, 14, _hoisted_19))
                                  }), 128)),
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["relative size-5 rounded-full cursor-pointer overflow-hidden flex items-center justify-center ring-offset-1 ring-offset-white", !_ctx.isPresetColor ? 'ring-2 ring-gray-900' : 'ring-1 ring-gray-200 hover:ring-gray-400']),
                                    style: _normalizeStyle(_ctx.isPresetColor ? { background: 'conic-gradient(from 0deg, #ef4444, #f59e0b, #10b981, #3b82f6, #8b5cf6, #ef4444)' } : { backgroundColor: _ctx.form.color }),
                                    title: _ctx.$t('edit_folder_modal.color_label')
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "color",
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.color) = $event)),
                                      class: "absolute inset-0 opacity-0 cursor-pointer"
                                    }, null, 512), [
                                      [_vModelText, _ctx.form.color]
                                    ])
                                  ], 14, _hoisted_20)
                                ]),
                                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('edit_folder_modal.color_help')), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "cursor-pointer inline-flex items-center rounded-md gap-2 bg-red-600 px-2 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600",
                              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openDeleteModal && _ctx.openDeleteModal(...args)), ["stop"]))
                            }, [
                              _createVNode(_component_TrashIcon, {
                                class: "size-4",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('edit_folder_modal.delete')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-gray-300 hover:bg-gray-50 cursor-pointer",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                              }, _toDisplayString(_ctx.$t('edit_folder_modal.cancel')), 1),
                              _createElementVNode("button", {
                                type: "submit",
                                disabled: _ctx.isCreating,
                                class: "ml-4 inline-flex justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-700 cursor-pointer"
                              }, _toDisplayString(_ctx.$t('edit_folder_modal.save')), 9, _hoisted_24)
                            ])
                          ])
                        ], 32)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_DeleteFolderConfirmationModalComponent, {
      open: _ctx.showDeleteModal,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteModal = false)),
      onConfirmAction: _ctx.confirmDeleteFolder,
      title: _ctx.$t('folders.delete_confirmation_title'),
      message: _ctx.$t('folders.delete_confirmation_message'),
      "second-message": _ctx.$t('folders.delete_confirmation_second_message'),
      "button-text": _ctx.$t('folders.delete_confirmation_button')
    }, null, 8, ["open", "onConfirmAction", "title", "message", "second-message", "button-text"])
  ], 64))
}